import React, { useState } from 'react';
import { Outlet, NavLink, useLocation, Link } from 'react-router-dom';
import { MenuIcon, BellIcon, UserIcon, ChevronLeftIcon, HomeIcon, BarChart3Icon, LogOutIcon, FileTextIcon } from 'lucide-react';
import Logo from '../../components/Logo';
import { useAuth } from '../../contexts/AuthContext';
const DemoLayout = () => {
  const location = useLocation();
  const {
    logout
  } = useAuth();
  const [showSidebar, setShowSidebar] = useState(false);
  // Update navigation items for digital advisor
  const navigationItems = [{
    to: '/demo',
    label: 'Dashboard',
    icon: <HomeIcon className="w-5 h-5 mr-3" data-id="element-160" />
  }, {
    to: '/demo/advisor-assessment',
    label: 'Application Assessment',
    icon: <FileTextIcon className="w-5 h-5 mr-3" data-id="element-161" />
  }];
  return <div className="flex flex-col min-h-screen bg-neutral-50" data-id="element-162">
      {/* Header */}
      <header className="bg-white border-b border-neutral-100 sticky top-0 z-10" data-id="element-163">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-164">
          <div className="flex items-center" data-id="element-165">
            <button className="md:hidden mr-4 p-2 rounded-full hover:bg-neutral-50" onClick={() => setShowSidebar(!showSidebar)} aria-label="Toggle menu" data-id="element-166">
              <MenuIcon className="w-6 h-6 text-neutral-500" data-id="element-167" />
            </button>
            <Link to="/demo" className="flex items-center" data-id="element-168">
              <Logo data-id="element-169" />
            </Link>
          </div>
          <div className="flex items-center space-x-4" data-id="element-170">
            <button className="p-2 rounded-full hover:bg-neutral-50" aria-label="Notifications" data-id="element-171">
              <BellIcon className="w-6 h-6 text-neutral-400" data-id="element-172" />
            </button>
            <div className="flex items-center" data-id="element-173">
              <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center" data-id="element-174">
                <UserIcon className="w-5 h-5 text-white" data-id="element-175" />
              </div>
              <div className="ml-2 hidden md:block" data-id="element-176">
                <div className="text-sm font-medium" data-id="element-177">Ahmad Bakri</div>
                <div className="text-xs text-neutral-400" data-id="element-178">Digital Advisor</div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="flex flex-1" data-id="element-179">
        {/* Sidebar Navigation */}
        <aside className={`${showSidebar ? 'block' : 'hidden'} md:block w-64 bg-white border-r border-neutral-100 p-4 fixed md:sticky top-16 bottom-0 left-0 overflow-y-auto z-20`} data-id="element-180">
          <nav className="space-y-1" data-id="element-181">
            {navigationItems.map(item => <NavLink key={item.to} to={item.to} className={({
            isActive
          }) => `flex items-center p-3 rounded-lg hover:bg-neutral-50 ${isActive ? 'bg-neutral-50 text-primary font-medium' : 'text-neutral-400'}`} data-id="element-182">
                {item.icon}
                <span data-id="element-183">{item.label}</span>
              </NavLink>)}
            <button onClick={logout} className="flex items-center p-3 rounded-lg hover:bg-neutral-50 text-neutral-400 w-full" data-id="element-184">
              <LogOutIcon className="w-5 h-5 mr-3" data-id="element-185" />
              <span data-id="element-186">Sign Out</span>
            </button>
          </nav>
        </aside>
        {/* Main Content */}
        <div className="flex-1" data-id="element-187">
          {/* Page Content */}
          <main className="p-4 md:p-6" data-id="element-188">
            <div className="container mx-auto" data-id="element-189">
              <Outlet data-id="element-190" />
            </div>
          </main>
        </div>
      </div>
      {/* Footer */}
      <footer className="bg-white border-t border-neutral-100 py-4" data-id="element-191">
        <div className="container mx-auto px-4 text-center text-xs text-neutral-400" data-id="element-192">
          CMS Finance Demo - Securities Commission Malaysia Presentation
        </div>
      </footer>
    </div>;
};
export default DemoLayout;